// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"MiniFooter__materialize-textarea___37N2I","modal-2463794813":"MiniFooter__modal-2463794813___pYSFr","container":"MiniFooter__container___1Nh4n","socialIcons":"MiniFooter__socialIcons___J1iJ5","connectWithUs":"MiniFooter__connectWithUs___3tJEb","logoPadding":"MiniFooter__logoPadding___2mqLE","copyRight":"MiniFooter__copyRight___Xbk4D","miniFooterInSmall":"MiniFooter__miniFooterInSmall___2-JMS","miniFooterInBig":"MiniFooter__miniFooterInBig___3W-is","lineBelowSocialIcons":"MiniFooter__lineBelowSocialIcons___2GiRV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MiniFooter/MiniFooter.scss
// module id = 1499
// module chunks = 0